
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["cog-icon cog-i-download",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","focusable":"false","class":"cog-icon cog-i-download"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',[_c('path',{staticClass:"cog-i-download__ground",attrs:{"d":"M2.03 15.18h13.94"}}),_c('g',{staticClass:"cog-i-download__arrow"},[_c('path',{attrs:{"stroke-linecap":"square","d":"M4.64 7.2L9 11.56l4.36-4.36"}}),_c('path',{attrs:{"d":"M9 1.97v9.59"}})])])])
          )
        }
      }
    